import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Form, Button, Dropdown } from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import "react-bootstrap-typeahead/css/Typeahead.css";
import $ from "jquery";
import { Utils } from "../../../../Common/Utilis"
import _ from "lodash";
import { DailyActivityService } from "../../../../Common/Services/DailyActivity";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { resolve, reject } from "q";
export class DepositAuditSlideout extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            hotelName: "",
            slideOutData: [],
            coaList: []
        };
    }

    componentDidMount() {
        this.GetDAChartList();
    }

    GetDADepositAuditDetails = async () => {
        this.setState({ searchTerm: "", isDataLoading: true });
        const { row, parentState } = this.props;
        const { coaList } = this.state;

        try {
            let depositDataDetails =
                (await DailyActivityService.GetDADepositAuditDetails(
                    parentState.filterHotelId,
                    parentState?.selectedDate,
                    row?.auditID
                )) ?? [];

            depositDataDetails = depositDataDetails.map((x: any) => {
                const filterCoaData = coaList.filter((n) => n?.coa === x.coa);
                let defaultCOA: any = [];
                let objCOA: any = {};
                objCOA.id = x.coa;
                objCOA.label = filterCoaData[0]?.description;
                objCOA.coaName = filterCoaData[0]?.cName;
                defaultCOA.push(objCOA);
                x.defaultCoa = defaultCOA;
                x.isEdit = false;
                x.errExp = false;
                x.errAmt = false;
                x.errCoa = false;
                x.amount = Utils.currencyFormatWithOutdoller(x.amount);
                return x;
            });
            this.setState({ slideOutData: [] }, () => {
                this.setState({
                    slideOutData: depositDataDetails,
                    isDataLoading: false,
                });
            });
        } catch (error) {
            this.setState({ slideOutData: [], isDataLoading: false });
            console.error("Error fetching deposit data", error);
        }
    };

    GetDAChartList = async () => {
        this.setState({ isDataLoading: true });
        const { row, parentState } = this.props;

        try {
            let chartList =
                (await DailyActivityService.GetDAChartList(
                    "COA",
                    1,
                    parentState.filterHotelId,
                    row?.auditID
                )) ?? [];

            this.setState({ coaList: [] }, () => {
                this.setState({
                    coaList: chartList,
                }, () => {
                    this.GetDADepositAuditDetails();
                });
            });
        } catch (error) {
            this.setState({ coaList: [], isDataLoading: false });
            console.error("Error fetching deposit data", error);
        }
    };

    hideDASlideOut = () => {
        this.props?.close();
    }

    handleExpRow = (row: any) => {
        let { slideOutData } = this.state;
        slideOutData = slideOutData.map((items) => {
            if (items.rNo === row.rNo) {
                return { ...items, isEdit: true };
            } else {
                return items;
            }
        });
        this.setState((curr: any) => ({ ...curr, slideOutData, }));
    }

    handleInputChange = (e: any, rowIndex: any, row: any, type: any) => {
        let { slideOutData } = this.state;
        let { value } = e.target
        let cursorIndex = e.target.selectionStart;
        let index = slideOutData.findIndex((x: any) => x.rNo === row.rNo);
        if (type === "explanation" && index >= 0) {
            let inputId = "explanation_" + rowIndex;
            slideOutData[index].explanation = value.trimLeft();
            slideOutData[index].errExp = (slideOutData[index].explanation === "");
            this.setState({ slideOutData }, () => {
                $("#" + inputId).focus().prop("selectionEnd", cursorIndex);
            });
        } else if (type === "amount" && index >= 0) {
            let inputId = "amount_" + rowIndex;
            slideOutData[index]['amount'] = value.replace(/[^0-9]/g, '');
            slideOutData[index].errTax = (slideOutData[index].amount === "");
            this.setState({ slideOutData }, () => {
                $("#" + inputId).focus().prop("selectionEnd", cursorIndex);
            });
        }
    }

    updateExpRow = (row: any) => {
        let { slideOutData } = this.state;
        slideOutData = slideOutData.map((items) => {
            if (items.rNo === row.rNo) {
                if (items.explanation === "") {
                    Utils.toastError(
                        "Please enter the explanation",
                        {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        }
                    );
                    return { ...items, errExp: true };
                } else if (items.coa === "") {
                    Utils.toastError(
                        "Please select coa",
                        {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        }
                    );
                    return { ...items, errCoa: true };
                } else if (items.amount === "") {
                    Utils.toastError(
                        "Please enter correct amount",
                        {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        }
                    );
                    return { ...items, errAmt: true };
                } else {
                    return { ...items, isEdit: false, errExp: false, errCoa: false, errAmt: false };
                }
            } else {
                return items;
            }
        });

        this.setState((curr: any) => ({ ...curr, slideOutData, }), () => {
            this.createSaveUpdateDeleteReq('Update');
        });
    }

    createSaveUpdateDeleteReq = (ActionType) => {
        let { slideOutData } = this.state;
        const { row, parentState } = this.props;
        const entries: any[] = slideOutData.map((entry) => ({
            Type: (row?.type?.toLowerCase() === "cash"
                || row?.type?.toLowerCase() === "cash & checks" ? "Bank Deposits" : row?.type
            ),
            TypeID: row?.auditID,
            Amount: entry?.amount || 0.00,
            Explanation: entry?.explanation || "",
            Coa: entry?.coa || "",
            CreditCardNo: entry?.creditcardNo || "",
            UniqueNo: entry?.uniqueNo || 0,
        }));

        const Total = slideOutData.reduce(
            (acc, item: any) =>
                acc + (+Utils.removeInvaildCharFromAmount(item?.amount) || 0),
            0);
        // let Actual = 0;
        // if (Total == eval(VarianceOther) + eval(Variance)) {
        //     Actual = TotalPMS
        // }
        // else {
        //     Actual = eval(TotalCapture) - eval(Total);
        // }

        // let ActualOther = 0;
        // if (Total == eval(VarianceOther) + eval(Variance)) {
        //     ActualOther = TotalPMSOther
        // }
        // else {
        //     ActualOther = eval(TotalCaptureOther) - eval(Total);
        // }

        //const totalCreditAmount = data.reduce(
        //     (acc, item: any) =>
        //       acc + (+Utils.removeInvaildCharFromAmount(item?.creditAmount) || 0),
        //     0
        //   );

        const payload: any = {
            Date: parentState?.selectedDate,
            BackHID: parentState.filterHotelId,
            TotalPMS: row?.pmsTotal, // Not set
            TotalCapture: row?.actual, // Not set
            Variance: row?.variance, // Not set
            Actual: row?.actual, // Not set
            TotalPMSOther: row?.pmsTotal, // Not set
            TotalCaptureOther: row?.pmsTotal, // Not set
            VarianceOther: row?.pmsTotal, // Not set
            ActualOther: row?.pmsTotal, // Not set
            HasSlideData: true,
            DepositAuditEntryList: entries,
        };
        console.log(payload);
    }

    SaveDepositAudit = async (request) => {
        try {
            const response: any = await DailyActivityService.saveRevenueEntry(
                request
            );
            const { failedCount, failedEntries } = response;

            if (failedCount > 0) {
                toast.error(`${failedCount} entries failed to save`);
            } else {
                toast.success("Data saved successfully");
            }
            //this.props.setCurrentTabStatusOnValuesChanges(false);
            this.setState({ isModified: false });
            //this.fetchRevenueData();
            //this.props.refreshMainData();
        } catch (error) {
            toast.error("Failed to insert data");
        } finally {
            this.setState({ isDataSaving: false });
        }
    }

    deleteExpRow = (row: any) => {
        if (row.isEdit) {
            confirmAlert({
                title: "Delete",
                message: "Are you sure you want to delete?",
                buttons: [
                    {
                        label: "Yes",
                        onClick: () => this.handleDeleteDeposit(row),
                    },
                    {
                        label: "No",
                        onClick: () => reject(),
                    },
                ],
                closeOnEscape: false,
                closeOnClickOutside: false,
            });
        }
    }

    handleDeleteDeposit = (row: any) => {
        let { slideOutData } = this.state;
        //slideOutData = slideOutData.filter((o: any) => { return o.rNo !== row.rNo })
        this.setState({ slideOutData })
        return
    }

    addExplanationRow = () => {
        let { slideOutData } = this.state;
        let newRow = { rNo: slideOutData.length + 1, uniqueNo: 0, explanation: "", amount: "0.00", coa: "", creditCardNo: "", defaultCoa: [], isEdit: true, errExp: false, errAmt: false, errCoa: false };
        slideOutData.push(newRow);
        this.setState({ slideOutData }, () => {
            $(".react-bootstrap-table").animate({ scrollTop: 9999 }, 'slow')
        });
    }

    render() {
        const { slideOutData } = this.state;
        const editIcon = () => {
            return (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.25 11.0959V13.3759C0.25 13.5859 0.415 13.7509 0.625 13.7509H2.905C3.0025 13.7509 3.1 13.7134 3.1675 13.6384L11.3575 5.4559L8.545 2.6434L0.3625 10.8259C0.2875 10.9009 0.25 10.9909 0.25 11.0959ZM13.5325 3.2809C13.825 2.9884 13.825 2.5159 13.5325 2.2234L11.7775 0.468398C11.485 0.175898 11.0125 0.175898 10.72 0.468398L9.3475 1.8409L12.16 4.6534L13.5325 3.2809Z" fill="none" />
                </svg>
            )
        }

        const checkIcon = () => {
            return (
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.59617 7.90605L1.99367 5.30355C1.70117 5.01105 1.22867 5.01105 0.936172 5.30355C0.643672 5.59605 0.643672 6.06855 0.936172 6.36105L4.07117 9.49605C4.36367 9.78856 4.83617 9.78856 5.12867 9.49605L13.0637 1.56105C13.3562 1.26855 13.3562 0.796055 13.0637 0.503555C12.7712 0.211055 12.2987 0.211055 12.0062 0.503555L4.59617 7.90605Z" fill="#2CAF92" />
                </svg>
            )
        }

        const deleteIcon = () => {
            return (
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 4.75V12.25H3V4.75H9ZM7.875 0.25H4.125L3.375 1H0.75V2.5H11.25V1H8.625L7.875 0.25ZM10.5 3.25H1.5V12.25C1.5 13.075 2.175 13.75 3 13.75H9C9.825 13.75 10.5 13.075 10.5 12.25V3.25Z" fill="#2CAF92" />
                </svg>
            )
        }

        const columns = [
            {
                dataField: 'explanation',
                text: 'Explanation',
                formatter: (cell, row, rowIndex) => {
                    return row.isEdit ? (
                        <Form.Control
                            id={"explanation_" + rowIndex}
                            placeholder="Enter Explanation"
                            type="text"
                            className={`${row.errExp ? "borderError" : ""} editBox w-100 text-left`}
                            value={row.explanation === null || row.explanation === "" ? "" : row.explanation}
                            onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "explanation")}
                            maxLength={50}
                        />
                    ) : (
                        <EllipsisWithTooltip placement="bottom">{row.explanation}</EllipsisWithTooltip>
                    )
                },
                footerClasses: "taxaudit-footer",
                footer: (columnData, column) => {
                    return (
                        <button className="link-button" onClick={this.addExplanationRow}>Add Explanation</button>
                    )
                },
            }, {
                dataField: "coaName",
                text: "COA",
                headerClasses: "coa",
                classes: "coa-col",
                headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
                formatter: (cell: any, row: any, rowIndex: any) => {
                    let btnId = "COA" + rowIndex + "btn";
                    let id = "coa" + rowIndex + "ddl";
                    const defaultCoa = row.coa;
                    const clas = row.errCoa ? ("borderError coa" + rowIndex + "ddl") : ("coa" + rowIndex + "ddl");
                    return (
                        <div>
                            <div
                                id={id}
                                className="more-action single-select-image dropdown coa-select"
                            >
                                <Typeahead
                                    inputProps={{
                                        className: clas,
                                        title: defaultCoa,
                                    }}
                                    id={"coa" + rowIndex + "ddl"}
                                    options={this.state.coaList}
                                    placeholder={"Enter COA"}
                                    renderMenu={(results: any, menuProps) => (
                                        <Menu {...menuProps}>
                                            {results.map((result: any, index: any) => (
                                                <>
                                                    {result.label !== "" && (
                                                        <MenuItem
                                                            option={result}
                                                            position={index}
                                                        //onWheel={() => this.hoverOutEllipsis()}
                                                        >
                                                            <EllipsisWithTooltip placement="bottom">
                                                                {result.label}
                                                            </EllipsisWithTooltip>
                                                        </MenuItem>
                                                    )}
                                                    {result.label === "" && (
                                                        <MenuItem
                                                            className="load-more"
                                                            option={result}
                                                            position={index}
                                                        >
                                                            Load More
                                                        </MenuItem>
                                                    )}
                                                </>
                                            ))}
                                        </Menu>
                                    )}
                                    onChange={this.handleSelectedItem.bind(
                                        this,
                                        2 + "_" + rowIndex
                                    )}
                                    selected={row.defaultCoa}
                                //   onBlur={this.handleOutsideClick.bind(this, rowIndex)}
                                />
                            </div>
                        </div>
                    );
                },
            },
            {
                dataField: 'amount',
                text: 'Amount',
                headerClasses: "text-right width-160",
                classes: "text-right",
                formatter: (cell, row, rowIndex) => {
                    return row.isEdit ? (
                        <Form.Control
                            id={"amount_" + rowIndex}
                            type="text"
                            placeholder="0.00"
                            className={`${row.errAmt ? "borderError" : ""} editBox w-100 text-right`}
                            value={Utils.removecurrencyFormat(row.amount === null || row.amount === "" ? "" : row.amount)}
                            onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "amount")}
                            maxLength={11}
                        />
                    ) : (
                        <EllipsisWithTooltip placement="bottom">{Utils.currencyFormatWithOutdoller(row.amount)}</EllipsisWithTooltip>
                    )
                },
                footerClasses: "taxaudit-footer",
                footer: '',
            },
            {
                dataField: '',
                text: '',
                headerClasses: "text-right width-70",
                classes: "exemptTax-Expbutton text-right ",
                formatter: (cell, row, rowIndex) => {
                    return row.isEdit ? (
                        <div className="d-flex">
                            <Button onClick={() => this.updateExpRow(row)} className="btn-outline-primary border-0 more">{checkIcon()}</Button>
                            <Button onClick={() => this.deleteExpRow(row)} className="btn-outline-primary border-0 more">{deleteIcon()}</Button>
                        </div>
                    ) : (
                        <Button onClick={() => this.handleExpRow(row)} className="btn-outline-primary border-0 more">{editIcon()}</Button>
                    )
                },
                footerClasses: "taxaudit-footer",
                footer: '',
            }

        ];

        return (
            <div className="DA-slideout transaction-slideout pos-fxd index-1000">
                <div className="d-flex">
                    <div className="back-drop viewer-panel opacity" onClick={() => this.hideDASlideOut()}></div>
                    <Container id="SlideBody" fluid className="body-sec viewer-panel">
                        <div className="page-heading pos-sticky underline d-flex">
                            <div className="mr-auto d-flex align-items-center">
                                {this.props?.row?.type}
                            </div>
                            <div className="action-group d-flex">
                                <button type="button" className="btn wht-bg cross" onClick={this.hideDASlideOut}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z" fill="#84888C" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="DA-Parent">
                            <div className="da-filter-sec py-2 bg-white">
                                <div className="vendor-type-sec d-flex">
                                    <div className="d-flex flex-wrap mr-auto">
                                        <ul className="d-flex DAgroup-boxul">
                                            <li>
                                                <div className="label">
                                                    PMS Total
                                                </div>
                                                <div className="value">{this.props?.row?.pmsTotal}</div>
                                            </li>
                                            <li>
                                                <span className="label">Actual</span>
                                                <div className="value">{this.props?.row?.deposit}</div>
                                            </li>
                                            {/* <li>
                                                <span className="label">Variance</span>
                                                <div className="value bg-red">{this.props?.row?.variance}</div>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="catagoty-list DaAuditTable">
                            <div className="auditTable-ttl">Explanations</div>
                            <BootstrapTable
                                id="tblSlide"
                                keyField="RNo"
                                data={slideOutData}
                                columns={columns}
                            //rowEvents={this.rowEvents}
                            />
                        </div>
                    </Container>
                </div >
            </div>
        );
    }

    handleCOAFocus = (ddlID) => {
        $("input[class^='" + ddlID + "']").focus();
    }

    handleSelectedItem = (control: any, id: any) => {
        let isStateChanged = true;
        let controlID = Number(control.split("_")[0]);
        let rowIndex = Number(control.split("_")[1]);
        let slideOutData = Object.assign(
            [],
            JSON.parse(JSON.stringify(this.state.slideOutData))
        );

        if (controlID === 2) {
            if (id.length > 0) {
                if (id[0].rNo > 0) {
                    slideOutData[rowIndex].coaName = id[0].coAname;
                    slideOutData[rowIndex].coa = id[0].id;
                    slideOutData[rowIndex].defaultCoa = id;
                    slideOutData[rowIndex].errCoa = false;
                } else {
                    slideOutData[rowIndex].coaName = "";
                    slideOutData[rowIndex].coa = "";
                    slideOutData[rowIndex].defaultCoa = [];
                    slideOutData[rowIndex].errCoa = true;
                }
            } else {
                slideOutData[rowIndex].coaName = "";
                slideOutData[rowIndex].coa = "";
                slideOutData[rowIndex].defaultCoa = [];
                slideOutData[rowIndex].errCoa = true;
            }
            this.setState({ slideOutData, isStateChanged }, () => {
                let txtID =
                    "rbt-input-main form-control rbt-input coa" + rowIndex + "ddl";
                $("#tblSlide")
                    .find("input[class^='" + txtID + "']")
                    .focus();
            });
        }
    };
}